import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  return (
    <>
      <nav
  className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
    scrolled
      ? "bg-white/70 backdrop-blur-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] py-2"
      : "bg-transparent py-4"
  }`}
>
        <div className="px-6 md:px-16">
          <div className="relative flex items-center justify-between">

            {/* SINISTRA */}
            <div
              className={`hidden md:flex gap-8 text-sm font-medium transition-all duration-300 ${
                scrolled
                  ? "text-alkimya-navy"
                  : "text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]"
              }`}
            >
              <Link to="/">Home</Link>
<Link to="/chi-siamo">Chi Siamo</Link>
<Link to="/trattamenti">Trattamenti</Link>
<Link to="/gallery">Gallery</Link>
            </div>

            {/* LOGO CENTRO */}
          <div className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center">
<Link to="/" className="logo-hover flex flex-col items-center">
  <svg
  
  viewBox="0 0 1228.8 1228.8"
className={`logo-bloom logo-shine logo-bloom-start transition-all duration-700 ${
  scrolled
    ? "logo-open h-16 md:h-[72px] scale-95 drop-shadow-[0_4px_10px_rgba(0,0,0,0.25)]"
    : "h-24 md:h-[112px] scale-100 drop-shadow-[0_6px_25px_rgba(0,0,0,0.45)]"
}`}
>
      <g
  className={`origin-center transition-all duration-700 ${
    menuOpen ? "petal-open" : ""
  }`}
>
  <defs>

 <linearGradient id="glassFill" x1="0%" y1="0%" x2="100%" y2="100%">
  {scrolled ? (
    <>
      <stop offset="0%" stopColor="#4d4d4f" stopOpacity="0.9"/>
      <stop offset="100%" stopColor="#4d4d4f" stopOpacity="0.6"/>
    </>
  ) : (
    <>
      <stop offset="0%" stopColor="white" stopOpacity="0.9"/>
      <stop offset="100%" stopColor="white" stopOpacity="0.3"/>
    </>
  )}
</linearGradient>

</defs>
      {/* I TUOI PATH */}
          <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1" d="M612.9,345.4c-35.82,44.23-63.56,96.92-73.5,153.5,29.2,23.31,52.46,52.63,74.5,82.5,20.6-30.7,44.43-59.41,73.5-82.5-9.3-55.51-37.11-111.52-74.5-153.5Z"/>
         <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M393.9,445.4c-10.32,128.46,64.61,274.65,186,325-72.67-69.68-81.81-176.34-60.5-270.5-35.85-27.9-80.52-47.15-125.5-54.5Z"/>
          <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M827.9,445.4c-4.51.1-22.43,5.39-28,7-32.12,9.32-66.02,27.32-92.5,47.5,19.83,94.55,12.39,199.73-59.5,270.5,121.74-52.68,193.67-194.66,185.5-324.5Z"/>
          <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M534.9,518.4c-16.99,88.27-5.66,184.24,65,246-9.26-37.5-14.62-76.92-8.5-115.5,1.78-11.2,12.44-38.68,11-47-1.17-6.75-24.39-39-30-46Z"/>
          <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M690.9,518.4c-15.34,12.39-66.52,70.35-66.5,87.5.01,6.61,8.39,27.22,10,36,7.56,41.09,4.49,82.62-7.5,122.5,70.51-60.74,82.07-158.83,64-246Z"/>
        <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M328.9,573.4c-18.84.58-44.54,3.29-63,7-4.4.89-24.55,4.75-24.5,8.5.04,2.77,22.64,43.4,26,49,33.78,56.3,93.01,124.93,153.5,152.5,57.83,26.36,123.03,25.34,183.5,8.5-105.15-30.73-178.46-121.5-212.5-222.5-20.91-1.8-41.95-3.65-63-3Z"/>
         <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M870.9,573.4c-4.27.15-34.99,2.45-36.5,3.5-32.8,101.04-108.64,193.39-214,222,37,7.99,74.38,15.13,112.5,11.5,120.25-11.45,203.57-122.73,253.5-222.5-35.65-11.46-77.88-15.83-115.5-14.5Z"/>
          <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M612.9,636.4c-8.46,34.03-7.04,69.97,1,104,6.97-34.09,11.22-70.49-1-104Z"/>
         <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M397.9,799.4c-22.76,20.71-44.81,42.43-61.5,68.5,77.14,25.38,166.32,10.06,230-41-57.34,9.96-116.59-2.83-168.5-27.5Z"/>
         <path
  className="petal transition-all duration-700"
  fill="url(#glassFill)"
  stroke="rgba(255,255,255,0.45)"
  strokeWidth="1"d="M826.9,799.4c-2.23.18-33.66,15.7-41,18-39.68,12.4-83.48,16.44-124.5,9.5,62.8,51.68,152.9,66.23,230,41-10.38-15.29-21.06-30.72-34-44Z"/>
   </g>
   </svg>

    <span
  className={`logo-bloom -mt-3 text-[11px] tracking-[0.35em] font-light transition-all duration-500 whitespace-nowrap ${
    scrolled
      ? "opacity-0 -translate-y-2 text-alkimya-navy"
      : "opacity-100 text-white"
  }`}
>
  ALKIMYA&nbsp;ESTETICA
</span>
  </Link>
</div>
            {/* DESTRA */}
            <div className="hidden md:flex ml-auto">
  <Link
    to="/consulenza"
    className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 tracking-wide ${
  scrolled
    ? "bg-alkimya-beige text-white shadow-lg"
    : "bg-silver/80 backdrop-blur-md text-white border border-white/20 shadow-md"
}`}
  >
   Consulenza Gratuita
  </Link>
</div>

 {/* HAMBURGER MOBILE */}
<button
  onClick={() => setMenuOpen(!menuOpen)}
  className="
md:hidden ml-auto relative w-12 h-12 flex items-center justify-center rounded-full
bg-black/40 backdrop-blur-md
border border-white/20
shadow-lg
transition-all duration-300
hover:scale-105
"
>
  <div className="relative w-6 h-6">

   <span
  className={`absolute left-0 w-6 h-[2px] bg-white transition-all duration-300 ${
    menuOpen ? "rotate-45 top-[11px]" : "top-[3px]"
  }`}
/>

<span
  className={`absolute left-0 w-6 h-[2px] bg-white transition-all duration-300 ${
    menuOpen ? "opacity-0" : "top-[11px]"
  }`}
/>

<span
  className={`absolute left-0 w-6 h-[2px] bg-white transition-all duration-300 ${
    menuOpen ? "-rotate-45 top-[11px]" : "top-[19px]"
  }`}
/>

  </div>
</button>
          </div>
        </div>
      </nav>

    {/* MOBILE MENU */}
{menuOpen && (
  <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-2xl flex flex-col items-center justify-center text-white">

    {/* BOTTONE CHIUSURA */}
    <button
      onClick={() => setMenuOpen(false)}
      className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center
                 rounded-full border border-white/30 text-4xl"
    >
      ×
    </button>

    {/* LINK MENU */}
    <div className="flex flex-col items-center gap-12 text-4xl font-serif tracking-wide">
<Link to="/trattamenti" onClick={() => setMenuOpen(false)} className="menu-link">
  Trattamenti
</Link>

<Link to="/" onClick={() => setMenuOpen(false)} className="menu-link">
  Home
</Link>

<Link to="/chi-siamo" onClick={() => setMenuOpen(false)} className="menu-link">
  Chi siamo
</Link>

<Link to="/gallery" onClick={() => setMenuOpen(false)} className="menu-link">
  Gallery
</Link>

<Link to="/consulenza" onClick={() => setMenuOpen(false)} className="menu-link">
  Consulenza
</Link>

    </div>

  </div>
)}
    </>
  );
}